import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioIconName } from '@resident-nx/shared';
import { PdfAttachmentComponent } from '../../../pdf-attachment/pdf-attachment.component';
import { FileUploadValueAccessorDirective } from '../../../../../directives/form/file-upload-value-accessor.directive';
import { MAX_FILE_SIZE } from '../../../../../services/tickets/ticket-creation.service';
import { FileUploadButtonComponent } from '../../../../atoms/file-upload-button/file-upload-button.component';
import { ImmomioFormFieldComponent } from '@immomio/ui/form';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile-edit-name',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    PdfAttachmentComponent,
    FileUploadValueAccessorDirective,
    FileUploadButtonComponent,
    ImmomioFormFieldComponent,
  ],
  templateUrl: './user-profile-edit-name.component.html',
  styleUrl: './user-profile-edit-name.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class UserProfileEditNameComponent {
  controlContainer = inject(ControlContainer);
  parentForm = this.controlContainer.control;
  public maxFileSize = MAX_FILE_SIZE;
  protected readonly ImmomioIconName = ImmomioIconName;

  public removeFile(): void {
    this.parentForm.patchValue({
      name: {
        verificationFile: null,
      },
    });
  }
}
